/* eslint-disable import/order */
import { FormsPaths, LandingPagePaths } from '@/services/dictionaries/Paths';

import { AccessLevel } from '@dev/ee-api/ee-api-models';
import AccountStorageImage from '@/services/Layout/icons/accountstorage.svg';
import { ApplicationState } from '@/store';
/* eslint-disable jsx-a11y/control-has-associated-label */
import ContactOverviewImage from '@/services/Layout/icons/contactgrowth.svg';
import { Link } from 'react-router-dom';
import React from 'react';
import { StyledProps } from '../ContactOverview';
import { SubscribedTooltip } from '../index';
import { Typography as T } from '@dev/ee-components';
import { formatNumber } from '@/services/tools/formatNumber';
import { getContactsOverviewStore } from '@/store/contacts/actions';
import { getPaymentsUrl } from '@/services/tools/getPaymentsUrl';
import { links } from '@/services/dictionaries/links';
import { showAccountStorage } from '@/services/tools/showAccountStorage';
import styled from 'styled-components';
import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';
import useMobile from '@/services/hooks/useMobile';
import { useSecurity } from '@/services/hooks/useSecurity';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SectionHeader = styled.div<StyledProps>`
    & > div,
    & > span {
        display: inline-block;
        max-width: 50%;
        ${({ isMobile }): string =>
            isMobile &&
            `
    max-width:100%
    `}
    }
    & > .right {
        float: right;
    }
`;

const SliderOuterWrapper = styled.div<StyledProps>`
    width: 100%;
    overflow: hidden;
    margin-left: ${({ isMobile }): number => (isMobile ? 0 : 15)}px;
    position: relative;
`;

// const SliderNavigation = styled.div`
//     position: absolute;
//     left: 0;
//     z-index: 2;
//     & button {
//         background: #ffffff 0% 0% no-repeat padding-box;
//         border: 1px solid #e2e8f0;
//         opacity: 1;
//         width: 24px;
//         height: 24px;
//         line-height: 24px;
//         text-align: center;
//         display: inline-flex;
//         justify-content: center;
//         cursor: pointer;
//         &:disabled {
//             background: ${palette.gray[3]};
//             cursor: default;
//         }
//     }
//     & button svg {
//         fill: #677389;
//     }
//     & button:first-child {
//         border-right: 0;
//         border-radius: 4px 0px 0px 4px;
//     }
//     & button:last-child {
//         border-radius: 0px 4px 4px 0px;
//     }
//     & button:hover:not(:disabled) {
//         background-color: #335dff;
//     }
//     & button:hover:not(:disabled) svg {
//         fill: #fff;
//     }
// `;

const ContactLimitsContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    & div {
        height: 4px;
    }
    & .existing {
        background-color: #5457ff;
    }
    & .available {
        background-color: #e6e9f2;
    }
    & .notaccounted {
        background-color: #babcff;
    }
`;

const SliderWrapper = styled.div`
    width: 200%;
    position: relative;
    transition: all 1s;
    margin-left: 0;
    height: 290px;
    margin-top: 32px;
    display: flex;
`;

const SliderItem = styled.div`
    height: inherit;
    width: calc(50% - 15px);
    display: inline-block;
    margin-left: 0 !important;
    margin-right: 15px !important;
    position: relative;
    margin-top: 0 !important;
    margin-bottom: 0 !important;

    & .panelContent .MuiBox-root {
        display: flex;
        & svg {
            margin-left: 8px;
        }
    }
    &.board .boardsection {
        min-height: 61px;
        padding-top: 20px;
    }
`;

const SlideAccountStorage = (): JSX.Element => {
    const { account, config } = useSelector((state: ApplicationState) => state);
    const contactsOverview = useSelector(getContactsOverviewStore);
    const maxContacts = account.Overview?.MaxContacts
        ? account.Overview?.MaxContacts
        : account.GeneralInfo.PlanMaxContacts;
    const existingPercent = ((contactsOverview?.BilledContacts || 0) / maxContacts) * 100 || 0;
    const notaccountedPercent = 0;
    const availablePercent = 100 - (existingPercent + notaccountedPercent);
    const paymentsUrl = getPaymentsUrl(config.isStandalone);
    const isMobile = useMobile();
    const { t } = useTranslation();
    const { isReseller } = useSecurity();

    return (
        <SliderItem className="board graphicboardwrapper sliderItem accountStorage">
            <SectionHeader isMobile={isMobile} className="boardsection graphicboard">
                <T variant="h2">{t('accountstorage')}</T>
                <T variant="body1">
                    {t('accountstoragedesc1')}
                    {isReseller && account.GeneralInfo.AccountPaymentUrl && (
                        <>
                            <a href={account.GeneralInfo.AccountPaymentUrl} rel="noreferrer" target="_blank">
                                {t('upgrade')}
                            </a>{' '}
                            {t('accountstoragedesc2')}
                        </>
                    )}
                    {!isReseller && (
                        <>
                            <a href={paymentsUrl}> {t('upgrade')} </a>
                            {t('accountstoragedesc2')} {t('learnmoreabout')}
                            <a href={links.contactsCountingOnUnlimitedPlans} rel="noreferrer" target="_blank">
                                {' '}
                                {t('countingcontacts')}
                            </a>
                        </>
                    )}
                </T>
                {!isMobile && (
                    <div className="overviewimagecontainer">
                        <AccountStorageImage />
                    </div>
                )}
            </SectionHeader>
            <div className="boardsection widesection">
                <div className="panelContent">
                    <T variant="body1" className="pull-left">
                        {t('contactslimit')}
                        {SubscribedTooltip(
                            'contactgrowth__tooltip',
                            t('accountstoragetooltip', {
                                uploadedContacts: formatNumber(contactsOverview?.TotalContacts || 0),
                                // sentEmails: formatNumber(account.Overview.ContactCount),
                            })
                        )}
                    </T>
                    <T variant="h2" className="pull-right">
                        {formatNumber(contactsOverview?.BilledContacts || 0)} {t('of')} {formatNumber(maxContacts)}
                    </T>
                </div>
                <ContactLimitsContainer>
                    <div className="existing" style={{ width: `${existingPercent}%` }} />
                    <div className="notaccounted" style={{ width: `${notaccountedPercent}%` }} />
                    <div className="available" style={{ width: `${availablePercent}%` }} />
                </ContactLimitsContainer>
            </div>
        </SliderItem>
    );
};

// enum SliderPanel {
//     ContactGrowth,
//     AccountStorage,
// }
/**
 * Redner upselling/information slider on bottom-right of the screen. One part of it is a quick link for creating Forms and email templates, other one shows number of chanrged contacts on the account
 */
export const ContactsGrowth = (): JSX.Element => {
    const { account } = useSelector((state: ApplicationState) => state);
    const { t } = useTranslation();
    // const [slideno, setSlideno] = useState(SliderPanel.ContactGrowth);
    const { isApiBillingPlan } = useSecurity();
    const {
        linkInBio: { isLinkInBioInsteadLandingPageVisible },
    } = useDashboardElementVisibility();
    const canModifyForms = account.GeneralInfo.AccountAccessLevel.includes(AccessLevel.ModifyForms);
    const canModifyTemplates = account.GeneralInfo.AccountAccessLevel.includes(AccessLevel.ModifyTemplates);
    const isMobile = useMobile();
    const showStorage = showAccountStorage(
        isApiBillingPlan,
        account.GeneralInfo.IsSub,
        account.Overview.MaxContacts,
        account.GeneralInfo.PlanMaxContacts
    );

    return isMobile ? (
        showStorage && <SlideAccountStorage />
    ) : (
        <SliderOuterWrapper isMobile={isMobile}>
            {/* hidden based on ticket OKR-7086
            
            <SliderNavigation style={{ display: showStorage ? 'block' : 'none' }} dir="ltr">
                <button
                    id="slider-left-button"
                    disabled={slideno === SliderPanel.ContactGrowth}
                    onClick={(): void => {
                        setSlideno(SliderPanel.ContactGrowth);
                    }}
                >
                    <ChevronLeft fontSize="medium" />
                </button>
                <button
                    id="slider-right-button"
                    disabled={slideno === SliderPanel.AccountStorage}
                    onClick={(): void => {
                        setSlideno(SliderPanel.AccountStorage);
                    }}
                >
                    <ChevronRight fontSize="medium" />
                </button>
            </SliderNavigation> */}
            <SliderWrapper
                style={{
                    //  marginLeft: `-${slideno * 100}%`,
                    marginTop: isMobile && isApiBillingPlan && 0,
                }}
            >
                <SliderItem className="board graphicboardwrapper sliderItem">
                    <SectionHeader isMobile={isMobile} className="boardsection graphicboard">
                        <T variant="h2">{t('contactsgrowth')}</T>
                        <T variant="body1">
                            {t(
                                isLinkInBioInsteadLandingPageVisible
                                    ? 'contactsgrowthdesc_creator'
                                    : 'contactsgrowthdesc'
                            )}
                        </T>
                        {!isMobile && (
                            <div className="overviewimagecontainer">
                                <ContactOverviewImage />
                            </div>
                        )}
                    </SectionHeader>
                    {canModifyForms && !isMobile && (
                        <div className="boardsection">
                            <T variant="h3">
                                <Link to={FormsPaths.FormList}>{t('createwebform')}</Link>
                            </T>
                        </div>
                    )}
                    {canModifyTemplates && !isMobile && (
                        <div className="boardsection">
                            <T variant="h3">
                                <Link to={LandingPagePaths.LandingPageList}>
                                    {isLinkInBioInsteadLandingPageVisible ? t('createlinkinbio') : t('createlanding')}
                                </Link>
                            </T>
                        </div>
                    )}
                </SliderItem>
                {/* <SlideAccountStorage /> */}
            </SliderWrapper>
        </SliderOuterWrapper>
    );
};
